// extracted by mini-css-extract-plugin
export default {"searchIconWrapper":"_4f0b69dd"};